module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"myCommunities":"My Communities","sharedJournal":"My Shared Journal"},"es":{"myCommunities":"Mis Comunidades","sharedJournal":"Mi Bitácora Compartida"}}')
  delete Component.options._Ctor
}
